/**
 * 登降園 一括打刻のモーダル
 * @param {*} $scope
 * @param {*} $modalInstance
 * @param {*} editItem
 */
function bulkRegistTimeModalCtrl($scope, $modalInstance, editItem, absentUseKinds) {
  var options = [
    { id: 'start_time', label: '入室', type: 'attendance' },
    { id: 'left_time', label: '外室', type: 'attendance' },
    { id: 'back_time', label: '戻り', type: 'attendance' },
    { id: 'end_time', label: '退室', type: 'attendance' },
    { id: $scope.system.SCHEDULE_KIND_MEMBER, label: '-', type: 'schedule' },
    { id: $scope.system.SCHEDULE_KIND_ABSENT_SICK, label: '病欠', type: 'schedule' },
    { id: $scope.system.SCHEDULE_KIND_ABSENT_PERSONAL, label: '都合欠', type: 'schedule' },
  ];

  angular.forEach(absentUseKinds.kinds, function (kind) {
    switch (kind) {
      case $scope.system.SCHEDULE_KIND_ABSENT_MOURNING:
        options.push({ id: $scope.system.SCHEDULE_KIND_ABSENT_MOURNING, label: '忌引', type: 'schedule' });
        break;
      case $scope.system.SCHEDULE_KIND_ABSENT_SUSPENDED:
        options.push({ id: $scope.system.SCHEDULE_KIND_ABSENT_SUSPENDED, label: '出席停止', type: 'schedule' });
        break;
      case $scope.system.SCHEDULE_KIND_ABSENT_COVID19:
        options.push({ id: $scope.system.SCHEDULE_KIND_ABSENT_COVID19, label: 'コロナ欠', type: 'schedule' });
        break;
      case $scope.system.SCHEDULE_KIND_ABSENT_DISASTER:
        options.push({ id: $scope.system.SCHEDULE_KIND_ABSENT_DISASTER, label: '災害欠', type: 'schedule' });
        break;
    }
  });

  var defaultOption = $scope.bulkType === 'schedule' ? options[4] : options[0];
  $scope.kind = {
    options: options,
    selectedOption: defaultOption,
  };
  $scope.time = new Date();
  $scope.lists = editItem.lists;
  $scope.type = editItem.type;
  $scope.ok = function () {
    $modalInstance.close({
      time: $scope.time,
      kind: $scope.kind.selectedOption.id,
      content: $scope.content,
      isOverwriteContent: $scope.isOverwriteContent,
      type: $scope.type,
    });
  };
  $scope.cancel = function () {
    $modalInstance.dismiss();
  };
}

angular.module('inspinia').controller('bulkRegistTimeModalCtrl', bulkRegistTimeModalCtrl);
